import { validations } from "../../../../../config/validations/validations";
import { minName, maxName } from "../../../../../config/Validators";

export const rules: any = {
  name: () => [
    validations.required.text(),
    validations.min.text(minName),
    validations.max.text(maxName),
  ],
};
